<stages-dialog2 [classes]="$any('autoHeight small-dialog')" #dialog>
	<stages-dialog-header>
		<h1 translate="sudo"></h1>
	</stages-dialog-header>
	<div class="content sudo-dialog">
		<div class="panel" *ngIf="applicationContext">
			<form [formGroup]="sudoFormGroup" (stagesKeyUp)="onKeyUp($event)">
				<div class="form sudo-form">
					<p translate="{{ getMsgKey() }}.question"></p>
					<div class="sudo-cemtered">
						<div class="sudo-icon">
							<i class="ico ico-superuser-key"></i>
						</div>
					</div>
					<div class="input-container required" *ngIf="!applicationContext.superUser && !applicationContext.sso">
						<label class="input-label" for="sudoPassword" translate="user.password"></label>
						<input
							class="text fullsize"
							type="password"
							id="sudoPassword"
							name="sudoPassword"
							autocomplete="off"
							formControlName="sudoPassword"
							stagesAutofocus
						/>
						<div class="info">
							<div class="errors">
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('sudoPassword', 'required')"
									role="alert"
									translate="input.required"
								></div>
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('sudoPassword', 'incorrectPassword')"
									role="alert"
									translate="user.password.incorrect"
								></div>
								<div
									class="error"
									*ngIf="hasErrorAfterEditing('sudoPassword', 'accountLocked')"
									role="alert"
									translate="login.error.accountLocked"
								></div>
							</div>
						</div>
						<div *ngIf="captchaImage">
							<label class="input-label" for="captchaText" translate="login.captcha"></label>
							<input
								class="text captcha"
								type="text"
								id="captchaText"
								name="captchaText"
								autocomplete="off"
								formControlName="captchaText"
								(input)="resetValidity('sudoPassword', 'code')"
							/>
							<img [src]="'data:image/png;base64,' + captchaImage" alt="captcha-image" class="captcha-image" />
							<div class="info"></div>
						</div>

						<div class="input-container required" *ngIf="showCodeInput()">
							<label class="input-label" for="code" [translate]="'login.code.' + applicationContext.otpType"></label>
							<input
								#codeInput
								formControlName="code"
								type="text"
								id="code"
								name="code"
								class="text fullsize"
								required
								inputmode="numeric"
								pattern="[0-9]*"
								autocomplete="one-time-code"
								stagesAutofocus
							/>
							<div class="info">
								<div class="errors">
									<div
										class="error"
										*ngIf="hasErrorAfterEditing('code', 'required')"
										role="alert"
										translate="input.required"
									></div>
									<div
										class="error"
										*ngIf="hasErrorAfterEditing('code', 'incorrectCode')"
										role="alert"
										translate="login.error.code.verify.failed"
									></div>
									<div
										class="error"
										*ngIf="hasErrorAfterEditing('code', 'accountLocked')"
										role="alert"
										translate="login.error.accountLocked"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<footer>
			<stages-buttons-bottom [removeBoundaries]="true">
				<button type="action" class="button sm cancel" (click)="onCancel()" translate="cancel"></button>
				<button
					type="submit"
					class="button sm prime"
					(click)="onSave()"
					[disabled]="submitting || sudoFormGroup.invalid"
					translate="{{ getMsgKey() }}.button"
				></button>
			</stages-buttons-bottom>
		</footer>
	</div>
</stages-dialog2>
